import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { MdAutorenew } from "react-icons/md";
import { truncateText } from "../../helpers";
import { FaFileAlt } from "react-icons/fa";
import Tooltip from "../Tooltip";
import TenantMiniProfile from "../Common/TenantMiniProfile";
import { IoMdEye } from "react-icons/io";

const Table = ({
  apiData,
  setSelectedData,
  setIsRenewAgreement,
  setIsViewNotes,
}) => {
  const storageKey = `tenant_expiring_page`;
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  //const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);

  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const renewAgreement = (item) => {
    setIsRenewAgreement(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const notes = (item) => {
    setIsViewNotes(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  // const ActionBtns = (item) => {
  //   return (
  //     <div className="flex gap-4 ">
  //       <button
  //         onClick={() => goToDues('Tenant Info', item)}
  //         className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
  //       >
  //         {/* Edit */}
  //         <MdOutlineChevronRight className="text-gray-300" size={24} />
  //       </button>
  //     </div>
  //   );
  // };

  const ActionBtns = (item) => (
    <div className="flex items-center gap-3">
      <Tooltip label="Click to view and add notes">
        <button
          onClick={(e) => {
            e.stopPropagation();
            notes(item);
          }}
          className="text-gray-400 hover:text-blue-600 transition"
        >
          <FaFileAlt size={16} />
        </button>
      </Tooltip>
      <Tooltip label="View tenant details">
        <button
          onClick={() => goToDues("Tenant Info", item)}
          className="p-2 rounded-full text-gray-400 hover:bg-gray-100 transition"
        >
          <IoMdEye size={16} />
        </button>
      </Tooltip>
    </div>
  );


  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        //getProperty: getProperty(item),
        rent: <span class="text-gray-600 text-sm flex">{'₹' + item.rent}</span>,
        dues: getDues(item),
        roomNum: getPropertyName(item),
        expiryDate: item.agreementExpiry ? showExpiryData(item) : '-',
        moveInOutDate: moveInOutDate(item),
        status: combineStatusAndKyc(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    return <TenantMiniProfile
      tenantId={item.tenantId}
      name={item.tenantName}
      mobile={item.tenantMobile}
      profilePicture={item.profilePicture}
      kycStatus={item.kycStatus}
      //flatName={`${item.roomNum}, ${item.flatName}, ${item.propName}`}
      flatName={
        <div className="text-xs leading-5">
          <div>Room: {item?.roomNum}</div>
          {item?.flatName &&
            <div>Flat: {item?.flatName}</div>
          }
          <div>Property: {item?.propertyName}</div>
        </div>
      }
    />
  };

  const getStatus = (status) => {
    if (status === 1) {
      return <Unverified>Unverified</Unverified>;
    } else if (status === 2) {
      return <Vaccines>Vacant</Vaccines>;
    } else if (status === 3) {
      return <Linked>Linked</Linked>;
    } else if (status === 4) {
      return <Requested>Requested</Requested>;
    } else if (status === 5) {
      return <Occupied>Occupied</Occupied>;
    } else if (status === 6) {
      return <Moving>Moving Out</Moving>;
    } else if (status === 7) {
      return <Reserved>Reserved</Reserved>;
    }
  };

  const combineStatusAndKyc = (item) => {
    const statusElement = getStatus(item.status);
    //const kycElement = getKycStatus(item.kycStatus);
    return (
      <div className="flex gap-1 cursor-pointer" onClick={() => goToDues('Tenant Info', item)}>
        <span>{statusElement}</span>
        {/* <span>{kycElement}</span> */}
      </div>
    );
  };

  const goToDues = (clickOn, item) => {
    navigate(`/tenantdetails/l/${item.tenantId}`, {
      state: {
        tabName: clickOn,
        tabKey: "totalDues",
      },
    });
  };

  const getDues = (item) => {
    if (Number(item?.totalDues) === 0) {
      return (
        <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
          No dues
        </span>
      );
    }

    return <Amount>₹{item?.totalDues}</Amount>;
  };

  // const getDues = (item) => {
  //   return (
  //     <div className="flex items-center gap-2" onClick={() => notes(item)}>
  //       <Tooltip label="Click to view and add notes">
  //         <span className="text-gray-600 flex text-sm cursor-pointer bg-neutral-100 px-3 py-1 rounded-md inline-flex"
  //         // onClick={() => goToDues('Passbook', item)}
  //         >
  //           {"₹" + (item?.totalDues || 0)}
  //         </span>
  //       </Tooltip>
  //       {/* <button title="Notes" onClick={() => notes(item)}>
  //         <FaFileAlt className="text-gray-600 " size={14} />
  //       </button> */}
  //     </div>
  //   );
  // };

  const showExpiryData = (item) => {
    const daysLeft = moment(item.agreementExpiry).diff(moment(), "days");

    const urgencyStyle =
      daysLeft <= 15
        ? "bg-red-50 text-red-700"
        : daysLeft <= 30
          ? "bg-amber-50 text-amber-700"
          : "bg-slate-100 text-gray-700";

    return (
      <div className="flex items-center gap-2">
        <span
          className={`${urgencyStyle} px-3 py-1 rounded-full text-sm font-medium`}
        >
          {moment(item.agreementExpiry).format("DD, MMM YYYY")}
        </span>

        <button
          onClick={() => renewAgreement(item)}
          title="Renew Agreement"
          className="text-gray-500 hover:text-gray-800 transition"
        >
          <MdAutorenew size={18} />
        </button>
      </div>
    );
  };


  // const showExpiryData = (item) => {
  //   return (
  //     <span className={`text-gray-600 px-3 py-1 text-sm font-semibold cursor-pointer flex`}>
  //       {(moment(item.agreementExpiry).format('DD, MMM YYYY'))} <button onClick={() => renewAgreement(item)}><MdAutorenew className="text-gray-600 ml-2" size={20} /></button>
  //     </span>
  //   );
  // };

  const getPropertyName = (item) => {
    return (
      <div className="flex flex-col gap-0.5 cursor-pointer" onClick={() => goToDues("Tenant Info", item)}>
        <span className="text-gray-600 text-sm truncate"
          title={item.propName}
        >
          {truncateText(item.propName, 28)}
        </span>
        {item?.roomNum && (
          <span className="flex items-center gap-1 text-xs text-gray-400">
            Room {item.roomNum}
          </span>
        )}
      </div>
    );
  };

  const getBedsFloors = (item) => (
    <span
      className="text-sm text-gray-600 truncate cursor-pointer"
      title={item.propName}
      onClick={() => goToDues("Tenant Info", item)}
    >
      {truncateText(item.propName, 28)}
    </span>
  );

  const getBedsFloorsOld = (item) => {
    return (
      <span className={`text-gray-600 text-sm cursor-pointer`} onClick={() => goToDues('Tenant Info', item)}>
        {/* {'#' + item?.roomNum + ", " + item?.flatName} */}
        {truncateText(item.propName, 25)}
      </span>
    );
  };
  const moveInOutDate = (item) => {
    return (
      <div className="flex gap-3 ">
        <div className="flex flex-col ">
          <span>
            {item.moveInDate
              ? moment(item.moveInDate).format("DD, MMM YY")
              : "---"}
          </span>
          <span className="text-gray-400 font-medium text-xs">M.In Date</span>
        </div>
        <div className="flex flex-col">
          <span>
            {item.agreementExpiry
              ? moment(item.agreementExpiry).format("DD, MMM YY")
              : "---"}
          </span>
          <span className="text-gray-400 font-medium text-xs">Expiry Date</span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Property",
          accessor: "roomNum",
        },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Property",
        accessor: "roomNum",
      },
      {
        Header: "Rent",
        accessor: "rent",
      },
      // {
      //   Header: "Move In/Expiry",
      //   accessor: "moveInOutDate",
      // },
      {
        Header: "Dues",
        accessor: "dues",
      },
      {
        Header: "Expiry Date",
        accessor: "expiryDate",
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      // },

      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);
  useEffect(() => {
    //setCurrentPage(pageIndex); // Update current page on state change
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            const rowData = apiData[rowIndex];
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                // onClick={() =>
                //   navigate(`/tenantdetails/${rowData.tenantId}`, {
                //     state: { data: rowData },
                //   })
                // }
                //style={{ cursor: "pointer" }}
                >
                  {row.cells.map((cell, cellIndex) => {
                    const isActionCell = cell.column.id === "action";
                    return (
                      <Td
                        {...cell.getCellProps()}
                      // onClick={(event) => {
                      //   // Prevent row click for action button
                      //   if (isActionCell) event.stopPropagation();
                      // }}
                      // onClick={["name", "rent", "roomNum", "moveInOutDate", "status"].includes(cell.column.id) ? () => goToDues ('Tenant Info', cell) : null}

                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Bed/Floor</strong>{" "}
                          {data[rowIndex].roomNum}
                        </li>
                        <li>
                          <strong>Agreement Duration</strong>{" "}
                          {data[rowIndex].moveInOutDate}
                        </li>
                        <li>
                          <strong>Bed/Floor</strong>{" "}
                          {data[rowIndex].roomNum}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status/KYC Status</strong>{" "}
                          {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}

    </>
  );
};

const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-lg transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const  ActionBtnWrapper = tw.div`
//   flex flex-wrap items-center w-[110px] mb-1 gap-y-1 gap-x-1.5 mt-20 md:mt-0
// `;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`
  border-b
  hover:bg-slate-50
  transition
`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-lg transform transition duration-200 hover:scale-110 hover:shadow-md`;

const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer w-full min-w-0`;
const UserImage = tw.img`w-10 h-10 rounded-full `;

const IdUpload = tw.div`bg-green-100 text-green-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Personal = tw.div`bg-orange-100 text-orange-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Selfie = tw.div`bg-lime-100 text-lime-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const RentAgreement = tw.div`bg-teal-100 text-teal-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Verification = tw.div`bg-yellow-100 text-yellow-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const KycPending = tw.div`bg-blue-100 text-blue-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Unknown = tw.div`bg-zinc-100 text-zinc-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;

const Unverified = tw.div`bg-yellow-50 text-yellow-700 text-xs border-yellow-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Vaccines = tw.div`bg-blue-50 text-blue-700 text-xs border-blue-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Requested = tw.div`bg-lime-50 text-lime-700 text-xs border-lime-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Occupied = tw.div`bg-green-50 text-green-700 text-xs border-green-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Reserved = tw.div`bg-orange-50 text-orange-700 text-xs border-orange-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Linked = tw.div`bg-purple-50 text-purple-700 text-xs border-purple-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Moving = tw.div`bg-rose-50 text-rose-700 text-xs border-rose-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
//const Amount = tw.p`text-gray-600 text-sm flex`
const Amount = tw.p`text-sm font-medium text-rose-700 bg-rose-100 px-3 py-1 rounded-full cursor-default hover:bg-rose-200 transition inline-flex`

export default Table;
